
<v-card
    flat
    class  = "lm-border doc-entry mb-1 mr-1 v-flex"
    @click = "onShowDocument"
>
     <div style="display: block" class="pl-2 doc-col" :class = "background(hover)">
        <div class="doc-info v-flex">
            <!-- document type -->
            <div class="doc-filename">
                {{ version.name }}
            </div>
            <!-- document type -->

            <v-spacer />
        </div>

        <div class="doc-subinfo doc-filename">
            Version {{ version.version }}
        </div>
    </div>

    <v-spacer :class = "background(hover)" />

    <div style="display: block" :class = "background(hover)" class="doc-col">
        <div class="doc-date pr-2">
            {{ timeAsString(version.createdDate) }}
        </div>
        <div class="doc-subinfo" style="margin-top: -2px">
            {{ version.createdBy }}
        </div>
    </div>

    <div style="padding-top: 10px;" :class = "background(hover)">
        <v-menu
            v-model = "menu"
            offset-x
        >
            <template v-slot:activator="{ props }">
                <a
                    @click.stop = "onMenu"
                    v-bind="props"
                    style="margin-top: -5px"
                >
                    <v-icon size="24" :color = "hover || menu ? 'white' : ''">mdi-dots-vertical</v-icon>
                </a>
            </template>

            <v-list style="width: 250px; font-size: 15px">
                <v-list-item @click="onShowDocument">
                    <div class="v-flex">
                        <div class="menu-icon">
                            <i class="fas fa-eye"></i>
                        </div>
                        <div>{{ $t("dms.entry.menu.show") }}</div>
                    </div>
                </v-list-item>

                <v-list-item @click="onDownload">
                    <div class="v-flex">
                        <div class="menu-icon">
                            <i class="fas fa-download menu-icon"></i>
                        </div>
                        <div>{{ $t("dms.entry.menu.download") }}</div>
                    </div>
                </v-list-item>

                <v-divider class="mt-2 mb-2" />

                <v-list-item link>
                    <c-app-confirm-menu
                        :text      = "$t('dms.version.confirm.restore.query')"
                        :subtext   = "$t('dms.version.confirm.restore.text')"
                        @confirmed = "onRestore"
                    >
                        <template v-slot:button>
                            <div class="v-flex">
                                <div class="menu-icon">
                                    <i class="fas fa-recycle"></i>
                                </div>
                                <div>
                                    {{ $t("dms.version.menu.restore") }}
                                </div>
                            </div>
                        </template>
                    </c-app-confirm-menu>
                </v-list-item>

                <v-list-item link>
                    <c-app-confirm-menu
                        :text      = "$t('dms.version.confirm.delete.query')"
                        :subtext   = "$t('dms.version.confirm.delete.text')"
                        @confirmed = "onRemove"
                    >
                        <template v-slot:button>
                            <div class="v-flex">
                                <div class="menu-icon">
                                    <i class="fas fa-trash-alt"></i>
                                </div>
                                <div>
                                    {{ $t("dms.version.menu.remove") }}
                                </div>
                            </div>
                        </template>
                    </c-app-confirm-menu>
                </v-list-item>
         </v-list>
        </v-menu>
    </div>
</v-card>
